module.exports = "https://bin.bnbstatic.com/_next/static/images/Communications-9a48ce8604f8f349d6a10a8e8571debc.svg";